/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/app'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AppAssignmentTypesRouteImport } from './routes/app.assignment-types'
import { Route as AppAssignmentsRouteImport } from './routes/app.assignments'
import { Route as AppClassesRouteImport } from './routes/app.classes'
import { Route as AppDashboardRouteImport } from './routes/app.dashboard'
import { Route as AppLinksRouteImport } from './routes/app.links'
import { Route as SIdRouteImport } from './routes/s.$id'
import { Route as AppAssignIdRouteImport } from './routes/app.assign.$id'
import { Route as AppAssignmentsIdRouteImport } from './routes/app.assignments_.$id'
import { Route as AppAssignmentsNewRouteImport } from './routes/app.assignments_.new'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAssignmentTypesRoute = AppAssignmentTypesRouteImport.update({
  id: '/assignment-types',
  path: '/assignment-types',
  getParentRoute: () => AppRoute,
} as any)
const AppAssignmentsRoute = AppAssignmentsRouteImport.update({
  id: '/assignments',
  path: '/assignments',
  getParentRoute: () => AppRoute,
} as any)
const AppClassesRoute = AppClassesRouteImport.update({
  id: '/classes',
  path: '/classes',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppLinksRoute = AppLinksRouteImport.update({
  id: '/links',
  path: '/links',
  getParentRoute: () => AppRoute,
} as any)
const SIdRoute = SIdRouteImport.update({
  id: '/s/$id',
  path: '/s/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAssignIdRoute = AppAssignIdRouteImport.update({
  id: '/assign/$id',
  path: '/assign/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAssignmentsIdRoute = AppAssignmentsIdRouteImport.update({
  id: '/assignments_/$id',
  path: '/assignments/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAssignmentsNewRoute = AppAssignmentsNewRouteImport.update({
  id: '/assignments_/new',
  path: '/assignments/new',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/app/assignment-types': typeof AppAssignmentTypesRoute
  '/app/assignments': typeof AppAssignmentsRoute
  '/app/classes': typeof AppClassesRoute
  '/app/dashboard': typeof AppDashboardRoute
  '/app/links': typeof AppLinksRoute
  '/s/$id': typeof SIdRoute
  '/app/assign/$id': typeof AppAssignIdRoute
  '/app/assignments/$id': typeof AppAssignmentsIdRoute
  '/app/assignments/new': typeof AppAssignmentsNewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/app/assignment-types': typeof AppAssignmentTypesRoute
  '/app/assignments': typeof AppAssignmentsRoute
  '/app/classes': typeof AppClassesRoute
  '/app/dashboard': typeof AppDashboardRoute
  '/app/links': typeof AppLinksRoute
  '/s/$id': typeof SIdRoute
  '/app/assign/$id': typeof AppAssignIdRoute
  '/app/assignments/$id': typeof AppAssignmentsIdRoute
  '/app/assignments/new': typeof AppAssignmentsNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/app/assignment-types': typeof AppAssignmentTypesRoute
  '/app/assignments': typeof AppAssignmentsRoute
  '/app/classes': typeof AppClassesRoute
  '/app/dashboard': typeof AppDashboardRoute
  '/app/links': typeof AppLinksRoute
  '/s/$id': typeof SIdRoute
  '/app/assign/$id': typeof AppAssignIdRoute
  '/app/assignments_/$id': typeof AppAssignmentsIdRoute
  '/app/assignments_/new': typeof AppAssignmentsNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/sign-in'
    | '/app/assignment-types'
    | '/app/assignments'
    | '/app/classes'
    | '/app/dashboard'
    | '/app/links'
    | '/s/$id'
    | '/app/assign/$id'
    | '/app/assignments/$id'
    | '/app/assignments/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app'
    | '/sign-in'
    | '/app/assignment-types'
    | '/app/assignments'
    | '/app/classes'
    | '/app/dashboard'
    | '/app/links'
    | '/s/$id'
    | '/app/assign/$id'
    | '/app/assignments/$id'
    | '/app/assignments/new'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/sign-in'
    | '/app/assignment-types'
    | '/app/assignments'
    | '/app/classes'
    | '/app/dashboard'
    | '/app/links'
    | '/s/$id'
    | '/app/assign/$id'
    | '/app/assignments_/$id'
    | '/app/assignments_/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  SignInRoute: typeof SignInRoute
  SIdRoute: typeof SIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/assignment-types': {
      id: '/app/assignment-types'
      path: '/assignment-types'
      fullPath: '/app/assignment-types'
      preLoaderRoute: typeof AppAssignmentTypesRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/assignments': {
      id: '/app/assignments'
      path: '/assignments'
      fullPath: '/app/assignments'
      preLoaderRoute: typeof AppAssignmentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/classes': {
      id: '/app/classes'
      path: '/classes'
      fullPath: '/app/classes'
      preLoaderRoute: typeof AppClassesRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/dashboard': {
      id: '/app/dashboard'
      path: '/dashboard'
      fullPath: '/app/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/links': {
      id: '/app/links'
      path: '/links'
      fullPath: '/app/links'
      preLoaderRoute: typeof AppLinksRouteImport
      parentRoute: typeof AppRoute
    }
    '/s/$id': {
      id: '/s/$id'
      path: '/s/$id'
      fullPath: '/s/$id'
      preLoaderRoute: typeof SIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/assign/$id': {
      id: '/app/assign/$id'
      path: '/assign/$id'
      fullPath: '/app/assign/$id'
      preLoaderRoute: typeof AppAssignIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/assignments_/$id': {
      id: '/app/assignments_/$id'
      path: '/assignments/$id'
      fullPath: '/app/assignments/$id'
      preLoaderRoute: typeof AppAssignmentsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/assignments_/new': {
      id: '/app/assignments_/new'
      path: '/assignments/new'
      fullPath: '/app/assignments/new'
      preLoaderRoute: typeof AppAssignmentsNewRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAssignmentTypesRoute: typeof AppAssignmentTypesRoute
  AppAssignmentsRoute: typeof AppAssignmentsRoute
  AppClassesRoute: typeof AppClassesRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppLinksRoute: typeof AppLinksRoute
  AppAssignIdRoute: typeof AppAssignIdRoute
  AppAssignmentsIdRoute: typeof AppAssignmentsIdRoute
  AppAssignmentsNewRoute: typeof AppAssignmentsNewRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAssignmentTypesRoute: AppAssignmentTypesRoute,
  AppAssignmentsRoute: AppAssignmentsRoute,
  AppClassesRoute: AppClassesRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppLinksRoute: AppLinksRoute,
  AppAssignIdRoute: AppAssignIdRoute,
  AppAssignmentsIdRoute: AppAssignmentsIdRoute,
  AppAssignmentsNewRoute: AppAssignmentsNewRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  SignInRoute: SignInRoute,
  SIdRoute: SIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
